// extracted by mini-css-extract-plugin
export default {"info":"farm-details_info__-2bG+","contact":"farm-details_contact__crn77","actions":"farm-details_actions__zl6Ka"};